export type InboxItem = {
 id:string;kind:string;title:string;actor_name?:string;workspace_name?:string;workspace_id?:string;deck_id?:string;subject_id?:string;
 created_at:number;read:boolean;needs_action:boolean;can_accept?:boolean;resolution?:string;
};
export function inboxPresentation(item:InboxItem){
 const actor=item.actor_name?.trim();const subject=item.title?.trim()||'Untitled';
 const invitation=item.kind==='workspace.invited';
 const resolution=item.resolution||'pending';
 const resolved=invitation&&resolution!=='pending';
 const label:Record<string,string>={accepted:'Joined',declined:'Declined',expired:'Expired',revoked:'Withdrawn'};
 const titles:Record<string,string>={
  'deck.member_added':actor?`${actor} added you to ${subject}`:`You were added to ${subject}`,
  'deck.forked':actor?`${actor} created a copy of ${subject}`:`A new copy of ${subject}`,
  'deck.updated':actor?`${actor} updated ${subject}`:`${subject} was updated`,
  'task.completed':`Your Agent request is complete · ${subject}`,
  'task.failed':`Your Agent request needs attention · ${subject}`,
  'invitation.accepted':actor?`${actor} joined ${subject}`:`A member joined ${subject}`,
 };
 const href=item.deck_id?`/deck/${encodeURIComponent(item.deck_id)}`:item.workspace_id?`/w/${encodeURIComponent(item.workspace_id)}`:null;
 const type=invitation?(resolved?'notice':item.can_accept?'decision':'prerequisite'):item.kind==='task.failed'?'problem':'notice';
 return {type,invitation,resolved,status:resolved?(label[resolution]||'Unavailable'):null,
 title:invitation?(item.can_accept?`Invitation to ${subject}`:'Workspace invitation'):(titles[item.kind]||'Workspace activity'),
 description:invitation?(resolved?'':item.can_accept?'Create and share presentations with this workspace.':'Verify your email address before joining this workspace.'):item.kind==='task.failed'?'Open the conversation to review what happened.':item.kind==='task.completed'?'Open the conversation to see the result.':'',
 href:invitation?null:href,
 context:[item.workspace_name,new Date(item.created_at).toLocaleDateString()].filter(Boolean).join(' · '),
 };
}
